import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chart-cohort', 'IconChartCohort', [["path",{"d":"M3 9h18v-6h-18v18h6v-18","key":"svg-0"}],["path",{"d":"M3 15h12v-12","key":"svg-1"}]]);